import './ccf-wfi-icon.module.scss';

import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfWfiIconProps extends SvgIconProps {}
/**
 * Component used to display  align center Icon
 * @param props - CcfAcdIconProps
 * @example - <CcfWfiIcon />
 * @returns SVG of align center Icon
 */
export function CcfWfiIcon(props: CcfWfiIconProps) {
  return (
    <SvgIcon {...props}>
      <path fill="#dbdbdb" d="M31.2 10c0 0.662-0.538 1.2-1.2 1.2h-28c-0.662 0-1.2-0.538-1.2-1.2s0.538-1.2 1.2-1.2h28c0.662 0 1.2 0.538 1.2 1.2z"/>
      <path fill="#dbdbdb" d="M31.2 15.6c0 0.662-0.538 1.2-1.2 1.2h-28c-0.662 0-1.2-0.538-1.2-1.2s0.538-1.2 1.2-1.2h28c0.662 0 1.2 0.538 1.2 1.2z"/>
      <path fill="#dbdbdb" d="M31.2 21.2c0 0.662-0.538 1.2-1.2 1.2h-28c-0.662 0-1.2-0.538-1.2-1.2s0.538-1.2 1.2-1.2h28c0.662 0 1.2 0.538 1.2 1.2z"/>
      <path fill="#427667" opacity="0.17" d="M29.6 11.2l-2.4-2.4v2.4h2.4z"/>
      <path fill="#8eb577" opacity="0.17" d="M29.6 16.8l-2.4-2.4v2.4h2.4z"/>
      <path fill="#822ae1" opacity="0.17" d="M29.6 22.4l-2.4-2.4v2.4h2.4z"/>
      <path fill="#dbdbdb" d="M10.4 0.8c0.662 0 1.2 0.538 1.2 1.2v28c0 0.662-0.538 1.2-1.2 1.2s-1.2-0.538-1.2-1.2v-28c0-0.662 0.538-1.2 1.2-1.2z"/>
      <path fill="#dbdbdb" d="M16 0.8c0.662 0 1.2 0.538 1.2 1.2v28c0 0.662-0.538 1.2-1.2 1.2s-1.2-0.538-1.2-1.2v-28c0-0.662 0.538-1.2 1.2-1.2z"/>
      <path fill="#dbdbdb" d="M21.6 0.8c0.662 0 1.2 0.538 1.2 1.2v28c0 0.662-0.538 1.2-1.2 1.2s-1.2-0.538-1.2-1.2v-28c0-0.662 0.538-1.2 1.2-1.2z"/>
      <path fill="#0f9555" opacity="0.17" d="M11.6 30l-2.4-2.4h2.4v2.4z"/>
      <path fill="#a5c890" opacity="0.17" d="M17.2 30l-2.4-2.4h2.4v2.4z"/>
      <path fill="#105241" opacity="0.17" d="M22.8 30l-2.4-2.4h2.4v2.4z"/>
      <path fill="#369fa8" d="M8 4.4h16c1.767 0 3.2 1.433 3.2 3.2v16.8c0 1.767-1.433 3.2-3.2 3.2h-16c-1.767 0-3.2-1.433-3.2-3.2v-16.8c0-1.767 1.433-3.2 3.2-3.2z"/>
      <path fill="#50bac4" d="M27.2 7.6v16c0 1.767-1.433 3.2-3.2 3.2h-16c-1.767 0-3.2-1.433-3.2-3.2v-16c0-1.767 1.433-3.2 3.2-3.2h16c1.767 0 3.2 1.433 3.2 3.2z"/>
      <path fill="#0c2c5b" opacity="0.2" d="M18.137 19.097l-2.137 3.287-5.031-5.031 2.713-2.713 4.457 4.457z"/>
      <path fill="#8261c3" opacity="0.2" d="M18.492 17.161l4.305-2.765-6.798-6.798-1.883 5.188 4.374 4.374z"/>
      <path fill="#7554dd" opacity="0.2" d="M19.146 26.8h4.854c1.767 0 3.2-1.433 3.2-3.2v0-3.532l-6.167-6.169-5.033 9.755z"/>
      <path fill="#fff" d="M21.033 13.9h-5.033v-6.302l-5.031 9.755h5.031v6.301l5.033-9.755z"/>
      <path fill="#e5e5e5" d="M14.181 17.354h1.819v6.301l5.033-9.755h-3.398l-3.453 3.454z"/>
      
    </SvgIcon>
  );
}

export default CcfWfiIcon;
